// src/utils/invoiceUpload.js
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { storage } from '../config/firebase';

/**
 * Upload an invoice file to Firebase Storage
 * @param {File} file - The invoice file to upload
 * @param {string} appointmentId - The appointment ID
 * @param {string} userId - The user ID
 * @returns {Promise<string>} The download URL of the uploaded file
 */
export async function uploadInvoiceToStorage(file, appointmentId, userId) {
  try {
    console.log('Uploading invoice to Firebase Storage', {
      fileName: file.name,
      fileSize: file.size,
      fileType: file.type,
      appointmentId
    });

    // Validate file
    if (!file) {
      throw new Error('No file provided');
    }

    // Validate file type
    const allowedTypes = [
      'application/pdf',
      'image/jpeg',
      'image/jpg',
      'image/png',
      'image/webp'
    ];

    if (!allowedTypes.includes(file.type)) {
      throw new Error('סוג הקובץ לא נתמך. נא להעלות PDF או תמונה');
    }

    // Validate file size (10MB max)
    const maxSize = 10 * 1024 * 1024; // 10MB
    if (file.size > maxSize) {
      throw new Error('הקובץ גדול מדי. גודל מקסימלי: 10MB');
    }

    // Create a unique filename
    const timestamp = Date.now();
    const fileExtension = file.name.split('.').pop();
    const fileName = `invoice_${appointmentId}_${timestamp}.${fileExtension}`;

    // Create storage reference
    const storageRef = ref(storage, `invoices/${userId}/${fileName}`);

    // Upload file
    console.log('Starting file upload to:', `invoices/${userId}/${fileName}`);
    const snapshot = await uploadBytes(storageRef, file);

    console.log('File uploaded successfully, getting download URL');

    // Get download URL
    const downloadURL = await getDownloadURL(snapshot.ref);

    console.log('Invoice uploaded successfully', {
      fileName,
      downloadURL: downloadURL.substring(0, 50) + '...',
      size: snapshot.metadata.size
    });

    return downloadURL;

  } catch (error) {
    console.error('Error uploading invoice to Firebase Storage:', error);
    throw new Error(`שגיאה בהעלאת החשבונית: ${error.message}`);
  }
}
